<template>
  <div>
    <el-card>
      <!-- 搜索与添加区域 -->
      <el-row :gutter="20">
        <el-col :span="7">
          <el-input v-model="queryNewsInfo.searchTitle" placeholder="请输入新闻资讯名称" class="input-with-select">
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
        </el-col>
        <el-col :span="2.5">
          <el-button type="primary" @click="addNews">添加新闻资讯</el-button>
        </el-col>
        <el-col :span="2.5">
          <el-button type="primary" @click="openImgDialog">添加横幅图</el-button>
        </el-col>
        <el-col :span="2.5">
          <el-button type="primary" @click="openIntroImgDialog">添加新闻简介图 ( 首页 )</el-button>
        </el-col>
      </el-row>

      <!-- 表格区域 -->
      <el-table :data="newsList" style="width: 100%" border stripe>
        <el-table-column type="index" />
        <el-table-column prop="title" label="新闻资讯名称"  />
        <el-table-column prop="author" label="发布人" width="250" />
        <el-table-column prop="publishDate" label="发布时间" width="250"/>
        <el-table-column label="操作" width="160">
          <template #default="scope">
            <!-- 修改按钮 -->
            <el-tooltip
              effect="dark"
              content="修改"
              placement="top"
              :enterable="false"
            >
              <el-button type="primary" icon="el-icon-edit" size="mini" @click="handleEdit(scope.$index, scope.row)"></el-button>
            </el-tooltip>
            <!-- 删除按钮 -->
            <el-tooltip
              effect="dark"
              content="删除"
              placement="top"
              :enterable="false"
            >
              <el-button type="danger" icon="el-icon-delete" size="mini" @click="handleDelete(scope.$index, scope.row)"></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryNewsInfo.pageNum"
        :page-sizes="[5, 8, 10, 20]"
        :page-size="queryNewsInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>

      <!-- 添加横幅图dialog -->
      <el-dialog
        title="新闻资讯横幅图"
        :visible.sync="newsImgDialogVisible"
        width="30%"
        :before-close="closeNewsImgDialog"
        center
      >
        <el-upload
          action="string"
          :http-request="settingTopBackground"
          accept=".png,.jpg,.jpeg"
          :show-file-list="false">
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
        <div class="topBackgroundImg">
          <img :src="topBackgroundImg" alt="">
        </div>
        <div class="uploadTip">建议上传相同比例的横幅图</div>
      </el-dialog>

      <!-- 添加新闻简介图dialog -->
      <el-dialog
        title="新闻简介图 ( 首页 )"
        :visible.sync="newsIntroImgDialogVisible"
        width="410px"
        :before-close="closeNewsIntroImgDialog"
        center
      >
        <el-upload
          action="string"
          :http-request="updateNewsIntroImg"
          accept=".png,.jpg,.jpeg"
          :show-file-list="false">
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
        <div class="topBackgroundImg topBackgroundImg2">
          <img :src="newsIntroImg" alt="">
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import { getAdminNewsList, deleteNews, settingTopBackground, getTopBackground, updateNewsIntroImg, getNewsIntroImg } from '@/api/editNews'
export default {
  data () {
    return {
      // 获取新闻资讯列表的参数对象
      queryNewsInfo: {
        searchTitle: '', // 搜索名称
        pageNum: 1, // 当前的页数
        pageSize: 10 // 当前显示的多少条数据
      },
      // 新闻资讯列表
      newsList: [],
      // 总条数
      total: 0,
      newsImgDialogVisible: false,
      topBackgroundImg: '', // 横幅图图片
      newsIntroImgDialogVisible: false,
      newsIntroImg: '' // 新闻简介图（首页）
    }
  },
  created () {
    const pageNum = Number(this.$route.query.pageNum)
    const pageSize = Number(this.$route.query.pageSize)
    if (Number.isInteger(pageNum) && pageNum > 0) this.queryNewsInfo.pageNum = pageNum
    if (Number.isInteger(pageSize) && pageSize > 0) this.queryNewsInfo.pageSize = pageSize
    if (typeof this.$route.query.searchTitle === 'string') {
      this.queryNewsInfo.searchTitle = this.$route.query.searchTitle
    }
    // 获取新闻资讯列表
    this.getNewsList()
  },
  methods: {
    // 获取新闻资讯列表
    getNewsList () {
      getAdminNewsList(this.queryNewsInfo).then(res => {
        if (res.code == 0) {
          const list = res.data.data.filter(item => {
            item.author = '智会云科技'
            return item
          })
          this.newsList = list
          this.total = res.data.total
        } else {
          this.$message.error('获取新闻列表失败！')
        }
      })
    },
    // 关键字搜索
    search () {
      this.queryNewsInfo.pageNum = 1
      this.getNewsList()
    },
    // 点击添加新闻资讯 跳转路由
    addNews () {
      this.$router.push({ path: '/management/editNewsItem' })
    },
    // 点击编辑
    handleEdit (index, row) {
      // this.$router.push({path:'/management/editNewsItem',query:{id: row.id}});
      this.$router.push({
        name: 'editNewsItem',
        params: { id: row.id },
        query: {
          pageNum: this.queryNewsInfo.pageNum,
          pageSize: this.queryNewsInfo.pageSize,
          searchTitle: this.queryNewsInfo.searchTitle || undefined
        }
      })
    },
    // 点击删除
    handleDelete (index, row) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteNews(row.id).then(res => {
          if (res.code == 0) {
            this.$message.success('删除资讯成功！')
            this.getNewsList()
          } else {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 分页功能下拉选择器触发
    handleSizeChange (newSize) {
      this.queryNewsInfo.pageSize = newSize
      this.queryNewsInfo.pageNum = 1
      // 重新获取数据
      this.getNewsList()
    },
    // 监听页码值改变
    handleCurrentChange (newSize) {
      this.queryNewsInfo.pageNum = newSize
      // 重新获取数据
      this.getNewsList()
    },
    // 打开横幅图dialog
    openImgDialog () {
      this.newsImgDialogVisible = true
      this.getTopBackground()
    },
    // 添加或编辑新闻资讯横幅图图片
    settingTopBackground (params) {
      const formData = new FormData()
      formData.append('file', params.file)
      settingTopBackground(formData).then(res => {
        if (res.code == '-1') {
          this.$message.error('上传失败！')
        } else {
          this.getTopBackground()
        }
      })
    },
    // 获取新闻资讯横幅图图片
    getTopBackground () {
      getTopBackground().then(res => {
        if (res.code == 0) {
          this.topBackgroundImg = res.data.value
        } else {
          this.$message.error('获取资讯横幅图失败！')
        }
      })
    },
    // 添加横幅图dialog关闭
    closeNewsImgDialog () {
      this.newsImgDialogVisible = false
    },
    // 打开新闻简介图dialog
    openIntroImgDialog () {
      this.newsIntroImgDialogVisible = true
      this.getNewsIntroImg()
    },
    // 添加或编辑新闻简介图（首页）
    updateNewsIntroImg (params) {
      const formData = new FormData()
      formData.append('file', params.file)
      updateNewsIntroImg(formData).then(res => {
        if (res.code == '-1') {
          this.$message.error('上传失败！')
        } else {
          this.getNewsIntroImg()
        }
      })
    },
    // 获取新闻简介图（首页）
    getNewsIntroImg () {
      getNewsIntroImg().then(res => {
        if (res.code == 0) {
          this.newsIntroImg = res.data.value
        } else {
          this.$message.error('获取新闻简介图失败！')
        }
      })
    },
    // 添加新闻简介图dialog关闭
    closeNewsIntroImgDialog () {
      this.newsIntroImgDialogVisible = false
    }
  }
}
</script>

<style lang="less" scoped>
.topBackgroundImg{
  width: 100%;
  height: 180px;
  border: 1px solid;
  margin-top: 20px;
  img{
    width: 100%;
    height: 100%;
  }
}

.topBackgroundImg2{
  width: 350px;
  height: 230px;
  border: 1px solid;
  margin-top: 20px;
  img{
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.uploadTip{
  font-size: 12px;
  color: red;
  margin-top: 5px;
}
</style>
